import React, {createContext, useContext, useState, ReactNode} from 'react';

interface PermissionErrorContextType {
  errorMessage: string | null;
  showError: (message: string) => void;
  clearError: () => void;
}

const PermissionErrorContext = createContext<
  PermissionErrorContextType | undefined
>(undefined);

export const PermissionErrorProvider = ({children}: {children: ReactNode}) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const showError = (message: string) => {
    setErrorMessage(message);
  };

  const clearError = () => {
    setErrorMessage(null);
  };

  return (
    <PermissionErrorContext.Provider
      value={{errorMessage, showError, clearError}}>
      {children}
    </PermissionErrorContext.Provider>
  );
};

export const usePermissionError = () => {
  const context = useContext(PermissionErrorContext);
  if (!context) {
    throw new Error(
      'usePermissionError must be used within PermissionErrorProvider',
    );
  }
  return context;
};
